"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
function onWorkspaceMounted(workspace) {
    if (!workspace) {
        return;
    }
    var dataProvider = new index_1.SparqlDataProvider({
        endpointUrl: '/wikidata',
        imagePropertyUris: [
            'http://www.wikidata.org/prop/direct/P18',
            'http://www.wikidata.org/prop/direct/P154',
        ],
    }, index_1.WikidataSettings);
    var graphBuilder = new index_1.SparqlGraphBuilder(dataProvider);
    var loadingGraph = graphBuilder.getGraphFromConstruct("\n        CONSTRUCT { ?current ?p ?o. }\n        WHERE {\n            {\n            ?current ?p ?o.\n            ?p <http://www.w3.org/2000/01/rdf-schema#label> ?label.\n            FILTER(ISIRI(?o))\n            FILTER exists{?o ?p1 ?o2}\n            }\n        }\n        LIMIT 20\n        VALUES (?current) {\n            (<http://www.wikidata.org/entity/Q567>)\n        }");
    workspace.showWaitIndicatorWhile(loadingGraph);
    loadingGraph.then(function (_a) {
        var diagram = _a.diagram, preloadedElements = _a.preloadedElements;
        return workspace.getModel().importLayout({ diagram: diagram, preloadedElements: preloadedElements, dataProvider: dataProvider });
    }).then(function () {
        workspace.forceLayout();
        workspace.zoomToFit();
    });
}
var props = {
    ref: onWorkspaceMounted,
    viewOptions: {
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
